import { Component, computed, effect, inject, model, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { InputSearchComponent } from '@shared/components/input-search/input-search.component';
import { PaginateurComponent } from '@shared/components/paginateur/paginateur.component';
import { URL_FRANCE_COMPETENCES } from '@shared/models/urls-france-compétences';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { CertificationStore } from '../../../croisement-référentiel/store/certification.store';
import { TrigrammeTypeCertificationStore } from '../../gestion-trigramme-certification/store/trigrammes-type-certification.store';

@Component({
  selector: 'app-gestion-certification-list',
  imports: [
    PaginateurComponent,
    ReactiveFormsModule,
    RouterModule,
    InputSearchComponent,
    EmptyStateComponent,
    HlmTableImports,
    HlmTooltipImports,
    HlmCardImports,
    HlmSelectImports,
    BrnSelectImports,
    TrierParPipe,
  ],
  templateUrl: './gestion-certification-list.component.html',
})
export class GestionCertificationList implements OnInit {
  protected readonly store = inject(CertificationStore);
  protected readonly trigrammeStore = inject(TrigrammeTypeCertificationStore);

  filtres = model<{ nom: string }>();
  niveau = new FormControl<number | null>(null);

  entities = computed(() => this.store.getPaginated());
  trigrammes = computed(() => this.trigrammeStore.entities());

  protected urlFranceCompetences = URL_FRANCE_COMPETENCES;

  constructor() {
    effect(() => {
      const filtres = this.filtres();
      if (filtres) {
        const { nom } = filtres;

        this.store.charger({ recherche: nom! });
      }
    });
  }

  ngOnInit(): void {
    this.trigrammeStore.charger();
    this.store.setPageSize(9);
  }

  setTrigrammeType(trigrammeType: string, idCertification: string) {
    this.store.modifierTrigrammeType({ idCertification, trigrammeType });
  }
}
